import { getService } from '../../utils';

export const getNotificationsService = getService('notifications');
